module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('div', {
    staticClass: "col-sm-16"
  }, [_c('div', [_c('AmendmentRequestDetails', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_external),
      expression: "is_external"
    }]
  }), _vm._v(" "), _vm._l((_vm.returns.table), function(item) {
    return _c('div', {
      key: ("headers_" + (item.headers))
    }, _vm._l((item.headers), function(question, key) {
      return _c('renderer-block', {
        key: ("q_" + key),
        attrs: {
          "component": question
        }
      })
    }), 1)
  })], 2)])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720512ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/enter_return_question.vue
// module id = 1010
// module chunks = 0